import { OrderingInitialState, SetTableNumberAction } from '@reducers/ordering/types';

export const setTableNumber = (state: OrderingInitialState, action: SetTableNumberAction): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    tableNumber: action.payload.tableNumber,
  },
});
